import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2024 Nano Vision Tech.   All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
